export const APPLICATION_ENVIRONMENT_VALUES = [
  'production',
  'staging',
  'development',
  'testing',
] as const;

export type ApplicationEnvironmentValue =
  (typeof APPLICATION_ENVIRONMENT_VALUES)[number];

export const DEFAULT_APPLICATION_ENVIRONMENT: ApplicationEnvironmentValue =
  'production';

export const APPLICATION_TYPE = {
  webAndBackend: 'webAndBackend',
  backendOnly: 'backendOnly',
} as const;

export type ApplicationType =
  (typeof APPLICATION_TYPE)[keyof typeof APPLICATION_TYPE];

export const isApplicationType = (value: string): value is ApplicationType =>
  value === APPLICATION_TYPE.webAndBackend ||
  value === APPLICATION_TYPE.backendOnly;

export const toApplicationType = (
  isBackendOnly: boolean | null | undefined,
): ApplicationType =>
  isBackendOnly ? APPLICATION_TYPE.backendOnly : APPLICATION_TYPE.webAndBackend;

export const resolveApplicationEnvironment = (
  environment: string | null | undefined,
): string => environment || DEFAULT_APPLICATION_ENVIRONMENT;

type BusinessUnitIdentity = { id: string };

const toSortedIds = (units: readonly BusinessUnitIdentity[]): string[] =>
  units.map(({ id }) => id).sort();

export const hasSameBusinessUnitIds = ({
  current,
  next,
}: {
  current: readonly BusinessUnitIdentity[];
  next: readonly BusinessUnitIdentity[];
}): boolean => {
  const currentIds = toSortedIds(current);
  const nextIds = toSortedIds(next);

  return (
    currentIds.length === nextIds.length &&
    currentIds.every((id, index) => id === nextIds[index])
  );
};

export const formatBusinessUnitNames = (
  units: readonly { name: string }[],
): string | null =>
  units.length > 0 ? units.map(({ name }) => name).join(', ') : null;
